import React from 'react';
import getIcon from '../../dependenciesNavigation/src/icons';
import styled from 'styled-components';
import { DependencyUsage } from '../../../../../../../src/modules/Dependencies/api/models/dependency-usage.model';

const Styles = styled.div`
    &&& {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        margin: 10px 0;
        padding: 0 5px;
        border-radius: 5px;

        &:hover {
            text-decoration: underline;
        }

        .infoWrapper {
            margin-left: 5px;
            flex: 1 1 1px;
        }

        .infoWrapper_name {
            color: #555;
            font-size: 13px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            padding-right: 10px;
            width: 100%;
            line-height: 1.2;
        }

        .infoWrapper_type {
            color: #888;
            font-size: 11px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }
`;

export type ItemClickCallback = (item: DependencyUsage) => void;

export type ItemProps = {
    item: DependencyUsage;
    onItemClick: ItemClickCallback;
};

const Item = ({ item, onItemClick }: ItemProps) => {
    const TypeIconComponent = getIcon['DepsIcon'];

    return (
        <Styles onClick={() => onItemClick(item)}>
            <div>
                <TypeIconComponent fill="#069e19" width={22} height={22} />
            </div>
            <div className="infoWrapper">
                <h4 className="infoWrapper_name">{item.Name}</h4>
                <span className="infoWrapper_type">{item.Description}</span>
            </div>
        </Styles>
    );
};

export default Item;
